import type { BaseEntity } from '../base-entity.interface';

import { BroadcastResolution } from './enums/broadcast-resolution.enum';
import { PaymentSuppliers } from './enums/payment-suppliers.enum';
import { StoreCategory } from './enums/store-category.enum';
import { StoreType } from './enums/store-type';
import { CustomTheme } from './interfaces/custom-theme.interface';
import { ReminderOptions } from './interfaces/reminder-options.interface';
import { StoreAllowedDomain } from './interfaces/store-allowed-domain.interface';
import { StoreConfig } from './interfaces/store-config.interface';
import { StoreCustomCss } from './interfaces/store-custom-css.interface';
import { StoreFeatureFlags } from './interfaces/store-feature-flags.interface';
export class Store implements BaseEntity {
  allowedDomains?: StoreAllowedDomain[];
  bannerUrl!: string;
  broadcastResolution!: BroadcastResolution;
  carouselsSettings?: {
    horizontalViewCustomHeadContent?: string;
    verticalViewCustomHeadContent?: string;
  };
  cartQuantityControlsSupported?: boolean;
  checkoutRedirectRoute?: string;
  colorPalateSelector?: boolean;
  createdAt!: Date;
  createdBy!: string;
  currency!: string;
  customCss?: StoreCustomCss;
  customLoaderVideoURL?: string;
  defaultDateFormat?: string;
  defaultLanguage?: string;
  deleted?: boolean;
  emailsLogo!: string;
  externalCart?: boolean;
  externalUrl!: string;
  featureFlags!: StoreFeatureFlags;
  hideTerrificCart?: boolean;
  hostVideoGrid!: boolean;
  id!: string;
  industry!: string;
  ipAllowlist?: string[];
  isActiveEmbedSessionBtnExpand?: boolean;
  isAutoCheckoutEnabled?: boolean;
  isEmbedSessionBtnExpandClosedOnStart?: boolean;
  isPublished!: boolean;
  lastScheduledSyncTime?: number;
  lastSyncTime?: number;
  leadImagePosition?: number;
  liveForumSettings?: {
    senderEmail?: string;
  };
  loaderMediaId?: string;
  logoUrl!: string;
  maximumTimelineVideoLength?: number;
  mobileBannerUrl!: string;
  name!: string;
  paymentSupplier!: PaymentSuppliers;
  pictureInPicture!: boolean;
  priceFormat!: string;
  productsLogoUrl!: string;
  reminderOptions!: ReminderOptions;
  socialImportsMaxItemsPerImport?: number | null;
  socialImportsMaxOnDemandRequestsDaily?: number;
  storeCategory?: StoreCategory;
  storeConfig?: StoreConfig;
  storeMemberPriceDiscount?: number;
  storeType!: StoreType;
  stripe?: {
    publicKey?: string;
    secretKeyFirstChars?: string;
    stripeAccountId?: string;
  };
  taxName?: string;
  taxPercent?: number;
  theme!: CustomTheme;
  title?: string;
  totalSiteVisitors?: number;
  updatedAt!: Date;
  updatedBy!: string;
  url!: string;
  constructor(attrs?: Partial<Store>) {
    Object.assign(this, attrs);
  }
}
